import PivotGridMeasureProps from './Measures'
import Vue from 'vue'

let KendoPivotGridMeasure = {
    name: 'kendo-pivot-measure',
    render () {
        return Vue.prototype._e
    },
    mixins: [PivotGridMeasureProps]
}

export default KendoPivotGridMeasure


// WEBPACK FOOTER //
// ./packages/kendo-datasource-vue-wrapper/src/KendoPivotMeasure/index.js